export const USER_LEVEL_LABELS: Record<string, string> = {
    "0": "游客",
    "1": "免费体验版",
    "2": "个人版",
    "3": "创作者版",
    "4": "团队版",
    "5": "旗舰版",
};

export const ENTERPRISE_LEVELS = ["4", "5"] as const;

export function levelLabel(level?: string | null): string {
    if (!level) return "游客";
    return USER_LEVEL_LABELS[level] || level;
}

/**
 * 根据等级配置列表动态生成企业版下拉选项
 * 使用人数从 nw_member_level_config 表获取，不做硬编码
 */
export interface LevelOption {
    value: string;
    label: string;
}

export function buildEnterpriseLevelOptions(
    configs: { levelCode: string; levelName: string; userCount: number }[]
): LevelOption[] {
    return ENTERPRISE_LEVELS
        .map((code) => {
            const cfg = configs.find((c) => c.levelCode === code);
            if (cfg) {
                return { value: code, label: `${cfg.levelName}（最多 ${cfg.userCount} 人）` };
            }
            return { value: code, label: levelLabel(code) };
        });
}

/**
 * @deprecated 使用 buildEnterpriseLevelOptions() 从 API 动态获取
 * 保留作为 fallback，当 API 不可用时使用
 */
export const ENTERPRISE_LEVEL_OPTIONS: LevelOption[] = [
    { value: "4", label: "团队版（最多 3 人）" },
    { value: "5", label: "旗舰版（最多 8 人）" },
];

/**
 * @deprecated 使用等级配置 API 的 userCount 字段
 * 保留作为 fallback
 */
export function maxMembers(level?: string | null): number {
    if (level === "4") return 3;
    if (level === "5") return 8;
    return 1;
}

export function isEnterpriseLevel(level?: string | null): boolean {
    return level === "4" || level === "5";
}
